import { disableBodyScroll } from 'body-scroll-lock';
import BaseFeature from '../../foundation/base/base';


class Header extends BaseFeature {
	constructor(element) {
		super(element);

		this.initDomCache();

		this.el = element;
		this.lastKnownScrollY = 0;
		this.currentScrollY = 0;
		this.ticking = false;
		this.header = this.el;
		this.scrollDownThreshold = 180;
		this.scrollUpThreshold = 86;
		this.classes = {
			pinned: 'o-header--pinned',
			unpinned: 'o-header--unpinned',
			bodyPinned: 'u-site--header-pinned',
			bodyNavOpen: 'u-site--nav-open'
		};
		this.menuMobileBtn = this.el.querySelector('[data-js="menuMobileBtn"]');
		this.logoText = this.el.querySelector('[data-js="logoText"]');
		this.serviceMenu = this.el.querySelector('[data-js="serviceMenu"]');
		this.basketAlert = this.el.querySelector('[data-js="basketAlert"]');
		this.body = window.features.dom.body;
		this.mobileMenu = this.el.querySelector('.toggle-menu');
		this.notification = document.querySelector('.m-notofication__container');
		this.addEventListener();
	}


	addEventListener() {
		document.addEventListener('scroll', () => this.attachScroll());

		// Add class disable sticky position when basket in use
		if (this.basketAlert) {
			this.el.classList.add('has-active-basket');
		}

		// Open mobile menu
		if (this.menuMobileBtn) {
			this.menuMobileBtn.addEventListener('click', () => {
				document.querySelector('.toggle-menu').classList.add('is-open');
				document.querySelector('.toggle-menu').classList.add('is-active');
				disableBodyScroll(this.mobileMenu);
			});
		}

		// Appending the Logo text
		if (this.logoText) {
			this.el.append(this.logoText);
			setTimeout(() => {
				this.logoText.classList.add('is-visible');
			}, 200);
		}

		if (document.querySelector('.o-modal--open')) {
			// This class will be removed in its respected file: modal.js
			this.el.classList.add('is-active-overlay');
			document.querySelector('.o-modal--open').focus();
		}
	}

	attachScroll() {
		this.currentScrollY = window.pageYOffset;
		if (this.currentScrollY < this.scrollUpThreshold) {
			this.requestTick(false);
		} else if (this.currentScrollY > this.scrollDownThreshold) {
			this.requestTick(true);
		}
	}

	requestTick(update) {
		if (!this.ticking && !update) {
			requestAnimationFrame(this.removePin.bind(this));
		} else if (!this.ticking && update) {
			requestAnimationFrame(this.update.bind(this));
		}
		this.ticking = true;
	}

	update() {
		if (this.currentScrollY < this.lastKnownScrollY) {
			this.pin();
		} else if (this.currentScrollY > this.lastKnownScrollY) {
			this.unpin();
		}
		this.lastKnownScrollY = this.currentScrollY;
		this.ticking = false;
	}


	pin() {
		if (this.header.classList.contains(this.classes.unpinned)) {
			this.header.classList.remove(this.classes.unpinned);
			this.header.classList.add(this.classes.pinned);
		}
		if (!this.body.classList.contains(this.classes.bodyPinned)) {
			this.body.classList.add(this.classes.bodyPinned);
		}
	}


	unpin() {
		// Make it sticky on desktop
		if (this.notification) {
			this.pin();
		} else {
			if (this.header.classList.contains(this.classes.pinned)
				|| !this.header.classList.contains(this.classes.unpinned)) {
				this.header.classList.remove(this.classes.pinned);
				this.header.classList.add(this.classes.unpinned);
			}
			if (this.body.classList.contains(this.classes.bodyPinned)) {
				this.body.classList.remove(this.classes.bodyPinned);
			}
		}
	}

	removePin() {
		if (this.header.classList.contains(this.classes.pinned)) {
			this.header.classList.remove(this.classes.pinned);
		}
		if (this.header.classList.contains(this.classes.unpinned)) {
			this.header.classList.remove(this.classes.unpinned);
		}
		if (this.header.classList.contains(this.classes.pinned)) {
			this.header.classList.remove(this.classes.pinned);
		}
		this.ticking = false;
	}
}

export default Header;
